import { useEffect, useMemo, useState } from 'react';

import { ATTRIBUTES_SEARCH_PAGE_SIZE } from '../../constants/index.js';
import { useDataHubClient } from '../../context/DataHubClientContext.js';
import type { AttributeDefinition } from '../../services/dataHubService.interface.js';
import { DataHubService } from '../../services/dataHubService.js';

export interface UseAttributeDefinitionsResult {
  attributeDefinitions: AttributeDefinition[];
  isLoading: boolean;
  error: string | null;
}

export function useAttributeDefinitions(): UseAttributeDefinitionsResult {
  const client = useDataHubClient();
  const service = useMemo(() => new DataHubService(client), [client]);

  const [attributeDefinitions, setAttributeDefinitions] = useState<
    AttributeDefinition[]
  >([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    setIsLoading(true);
    setError(null);

    service
      .searchAttributeDefinitions({
        isActive: true,
        pageSize: ATTRIBUTES_SEARCH_PAGE_SIZE,
      })
      .then((result) => {
        if (cancelled) return;
        setAttributeDefinitions(result.items);
        setIsLoading(false);
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        setError(
          err instanceof Error ? err.message : 'Failed to load attributes',
        );
        setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [service]);

  return { attributeDefinitions, isLoading, error };
}
